module.exports = __webpack_public_path__ + "img/yin-yang.0b265ab7.png";